import { useRef } from 'react'

interface ProjectControlsProps {
  disabled: boolean
  onExport: () => void
  onImport: (file: File) => void
}

export function ProjectControls({ disabled, onExport, onImport }: ProjectControlsProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  return (
    <div className="sidebar-project-controls" aria-label="Project file controls">
      <strong>Project file</strong>
      <div className="action-row">
        <button className="secondary-button" type="button" disabled={disabled} onClick={onExport}>
          Export JSON
        </button>
        <button
          className="secondary-button"
          type="button"
          disabled={disabled}
          onClick={() => inputRef.current?.click()}
        >
          Import JSON
        </button>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="application/json,.json"
        hidden
        onChange={(event) => {
          const file = event.currentTarget.files?.[0]
          event.currentTarget.value = ''
          if (file) onImport(file)
        }}
      />
    </div>
  )
}
